<template>
  <Card class="h-full">
    <template #title>
      <div class="text-xl">Contract Details</div>
    </template>
    <template #content>
      <div class="grid">
        <div class="flex flex-column gap-1 col-12">
          <label for="contractType">Contract Type:</label>
          <Dropdown
            id="contractType"
            :modelValue="contractType"
            @update:modelValue="$emit('update:contractType', $event)"
            :options="contractTypes"
            placeholder="Select Type"
            optionLabel="label"
            optionValue="value"
            @change="$emit('contract-type-change')"
          />
        </div>
        <template v-if="contractType === 'cpm'">
          <div class="flex flex-column gap-1 col-12">
            <label for="cpm_per_geo">CPM per Geo</label>
            <div
              v-for="(item, index) in cpmPerGeo"
              :key="index"
              class="flex gap-1"
            >
              <Dropdown
                v-model="item.geo"
                :options="countryList"
                optionLabel="name.common"
                optionValue="cca2"
                placeholder="Select Country"
                filter
                class="w-full"
              />
              <InputText
                v-model.number="item.cpm"
                placeholder="Enter CPM"
                class="w-full"
              />
              <Button
                icon="pi pi-times"
                class="p-button-danger"
                text
                @click="$emit('remove-geo', index)"
              />
            </div>
            <div class="flex gap-1">
              <Dropdown
                placeholder="Rest Of The World"
                disabled
                class="w-full"
              />
              <InputText
                :modelValue="contractValue"
                @update:modelValue="
                  $emit('update:contractValue', Number($event))
                "
                placeholder="Enter CPM"
                class="w-full"
              />
              <Button
                icon="pi pi-times"
                class="p-button-danger"
                style="visibility: hidden"
                text
              />
            </div>
          </div>
          <div class="flex flex-column gap-1 col-12">
            <Button
              label="Add Country"
              icon="pi pi-plus"
              @click="$emit('add-geo')"
            ></Button>
          </div>
          <div v-if="rateChanges" class="col-12">
            <ScheduledRateChange :rate-changes="rateChanges" />
          </div>
        </template>
        <template v-else-if="contractType === 'revshare'">
          <div class="flex flex-column gap-1 col-12">
            <label for="contractValue">{{ contactValueLabel }}:</label>
            <input
              id="contractValue"
              type="range"
              min="0"
              max="95"
              step="5"
              :value="contractValue"
              @input="$emit('update:contractValue', $event.target.value)"
            />
            <span style="text-align: left; width: 20%">
              {{ contractValue }}%
            </span>
          </div>
        </template>
        <small v-if="submitted && !isValid" class="p-error"
          >Valid contract params are required</small
        >
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "primevue/card";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import ScheduledRateChange from "./ScheduledRateChange.vue";

defineProps({
  contractType: {
    type: String,
    default: "",
  },
  contractValue: {
    type: [Number, String],
    default: 0,
  },
  cpmPerGeo: {
    type: Array,
    default: () => [],
  },
  contractTypes: {
    type: Array,
    default: () => [],
  },
  countryList: {
    type: Array,
    default: () => [],
  },
  contactValueLabel: {
    type: String,
    default: "",
  },
  submitted: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: true,
  },
  // useSellerRateChanges() of an existing seller, null on create
  rateChanges: {
    type: Object,
    default: null,
  },
});
defineEmits([
  "update:contractType",
  "update:contractValue",
  "contract-type-change",
  "remove-geo",
  "add-geo",
]);
</script>
